import type { FeatureConfigState } from './featureConfigSingleton';
import { setFeatureConfigSingleton } from './featureConfigSingleton';

export const initFeatureConfig = (): void => {
    const EMPTY_FEATURE_CONFIGURATION: FeatureConfigState = {
        config: {},
        configWithoutOverrides: {},
    };
    setFeatureConfigSingleton(EMPTY_FEATURE_CONFIGURATION);
};
